/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function data(endpoints = [], onRowClick, expandedRow, onEditClick = () => {}) {
  const Endpoint = ({ name, url }) => (
    <MDBox display="flex" flexDirection="column">
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDBox ml={0} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography display="block" variant="caption" color="text">
            {url}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );

  const getDisplayName = (item) => item.displayName || item.DisplayName || "";
  const getEndpointPath = (item) => item.name || item.Name || "";
  const getDescription = (item) => item.description || item.Description || "";
  const getIsActive = (item) => {
    const value = item?.isActive ?? item?.IsActive;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "active";
    }
    return false;
  };

  return {
    columns: [
      {
        Header: "endpoint",
        accessor: "endpointSearch",
        width: "40%",
        align: "left",
        Cell: ({ row }) => (
          <Endpoint name={row.original.displayName} url={row.original.endpointPath} />
        ),
      },
      {
        Header: "description",
        accessor: "descriptionText",
        align: "left",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "status",
        accessor: "statusText",
        align: "center",
        Cell: ({ row }) => row.original.status,
      },
      {
        Header: "action",
        accessor: "actionText",
        align: "center",
        Cell: ({ row }) => (
          <Tooltip title="Edit Endpoint" placement="top">
            <IconButton size="small" color="info" onClick={() => onEditClick(row.original)}>
              <Icon>edit</Icon>
            </IconButton>
          </Tooltip>
        ),
      },
    ],

    rows: endpoints.map((item) => {
      const isActive = getIsActive(item);
      return {
        endpointId: item?.id ?? item?.Id ?? 0,
        rawIsActive: item?.isActive ?? item?.IsActive,
        displayName: getDisplayName(item),
        endpointPath: getEndpointPath(item),
        descriptionText: getDescription(item),
        statusText: isActive ? "active" : "inactive",
        status: (
          <MDBadge
            badgeContent={isActive ? "active" : "inactive"}
            color={isActive ? "success" : "secondary"}
            variant="gradient"
            size="sm"
          />
        ),
        endpointSearch: `${getDisplayName(item)} ${getEndpointPath(item)} ${getDescription(
          item
        )}`.trim(),
        actionText: "Edit",
      };
    }),
  };
}
